// @flow
import PropTypes from 'prop-types'
import { compose, lifecycle, setPropTypes } from 'recompose'

const propTypes = setPropTypes({
  isModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
})

const resetModal = lifecycle({
  componentWillMount() {
    this.props.isModalOpen && this.props.closeModal()
  }
})

const withResetModal = compose(propTypes, resetModal)

export default withResetModal



// WEBPACK FOOTER //
// ./src/services/modal/withResetModal.js